'use client';

import type { WeekOpeningHours } from '../../utilities/opening-hours';
import { resolveOpeningStatus } from '../../utilities/opening-status';
import { cn } from '../../utilities/classname';
import { useNow } from '../../utilities/hooks/use-now';

/** The cached page carries the schedule; only the browser reads the clock. */
export const OpeningStatus: React.FC<{
  hours: WeekOpeningHours;
  timeZone?: string | null;
  hoursId: string;
}> = ({ hours, timeZone, hoursId }) => {
  const now = useNow();
  const status = now ? resolveOpeningStatus({ hours, timeZone, now }) : null;

  return (
    <p
      className={cn('flex min-h-11 items-center gap-2 text-sm leading-6 lg:min-h-0', status?.isOpen && 'text-success')}
      title="Based on regular weekly opening hours"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {status ? (
        <>
          <span aria-hidden="true" className="size-2 shrink-0 rounded-full bg-current" />
          <span>{status.text}</span>
        </>
      ) : (
        <a className="link link-hover" href={`#${hoursId}`}>See opening hours</a>
      )}
    </p>
  );
};
